import { Seo } from '../components/Seo';
import { PaymentMethodsOverview } from '../components/PaymentMethodsOverview';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PaymentMethodsPage() {
  return (
    <>
      <Seo
        path="/betaalmethoden"
        title="Betaalmethoden"
        description="Welke betaalmethoden je bij ComfortTool™ kunt gebruiken: iDEAL, Bancontact, kaarten, Apple Pay, Google Pay, Klarna en meer — met korte uitleg."
        keywords="ComfortTool betalen, iDEAL, Stripe, Bancontact, Klarna, Apple Pay, betaalmethoden"
      />
      <div className="mx-auto max-w-6xl px-4 py-10 sm:py-14">
        <Link
          to="/prijzen"
          className="inline-flex items-center gap-2 text-sm font-semibold text-ct-accent hover:underline"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden />
          Terug naar prijzen
        </Link>

        <header className="mt-8 max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-ct-accent">Stripe Checkout</p>
          <h1 className="mt-3 text-3xl font-bold tracking-tight text-ct-text sm:text-4xl">
            Zo betaal je bij ComfortTool™
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-ct-muted sm:text-base">
            Hieronder zie je alle betaalmethoden die wij <strong className="text-ct-text">voor jou hebben ingeschakeld</strong>.
            Welke opties je op de betaalpagina ziet, hangt af van je land, bank en toestel — dat regelt Stripe automatisch.
          </p>
        </header>

        <div className="mt-12">
          <PaymentMethodsOverview />
        </div>
      </div>
    </>
  );
}
